import * as React from 'react';
import "./style.scss";
import ResultModal from '../../components/ResultModal/result';

export interface IFormHeaderLayoutProps {
    header: string;
    onCopy?: () => void;
    showCopy?: boolean;
    children: React.ReactNode;
}

export default function FormHeaderLayout (props: IFormHeaderLayoutProps) {

    const
        [showCopy, setShowCopy] = React.useState(false);
        
    React.useEffect(()=>{
        if(props.showCopy){
            setShowCopy(true);
        }
        else{
            setShowCopy(false);
        }
    },[props.header, props.showCopy])


    const onCopy = () => {        
        props.onCopy && props.onCopy();
    }

    return (
        <div className="gen-layout">
        <div className="img-header">
            <div className="container flexbox">
                <div className="grid">
                    <div className="all-hide m-show col-m-12">
                        
                    </div>
                    <div>  
                        <ResultModal onCopy={onCopy} result={props.header} show={showCopy}/>
                    </div>
                    <div className="col-6 m-hide" id="empty">
                        
                    </div>
                </div>
            </div>
        </div>       
        <div className="container flexbox">
            {props.children}
        </div>
    </div>  
    );
}